// extracted by mini-css-extract-plugin
module.exports = {"inner":"Manage_inner__zBQpO","text":"Manage_text__aECtC","mobile":"Manage_mobile__nNfQr","desktop":"Manage_desktop__GjCwa"};